export default "__VITE_ASSET__BRZcOVOI__"